import type { TreeTag } from '#domains/tags';
import filterAncestors from './filterAncestors';
import filterDecendants from './filterDecendants';

export const filterByQuery = (tags: TreeTag[], queryString: string) => {
  return tags
    .filter(tag => {
      return tag.name.toLocaleLowerCase().match(queryString.toLowerCase());
    })
    .flatMap(tag => {
      const ancestors = filterAncestors(tags, tag);
      const decendants = filterDecendants(tags, tag);

      return [
        ...ancestors.map(ancestor => {
          return { ...ancestor, open: true };
        }),
        tag,
        ...decendants
      ];
    });
};
